import * as XLSX from "xlsx";

// The four sheets a valid control document (file spec) must contain.
export const REQUIRED_SHEETS = [
  "Template User Guide",
  "File Level",
  "Column Level",
  "Allowable Values",
];

// Grid sheets (Column Level / Allowable Values): header row 0 + data rows.
function sheetToGrid(ws) {
  if (!ws) return { columns: [], rows: [] };
  const matrix = XLSX.utils.sheet_to_json(ws, {
    header: 1,
    blankrows: false,
    defval: "",
  });
  if (!matrix.length) return { columns: [], rows: [] };

  const columns = (matrix[0] || [])
    .map((c) => String(c).trim())
    .filter(Boolean);

  const rows = matrix.slice(1).map((r, i) => {
    const obj = { _key: i };
    columns.forEach((col, ci) => {
      obj[col] = r[ci] != null ? String(r[ci]) : "";
    });
    return obj;
  });

  // Drop fully-empty rows
  const nonEmpty = rows.filter((row) =>
    columns.some((c) => (row[c] || "").trim() !== ""),
  );
  return { columns, rows: nonEmpty };
}

// File Level is a vertical key/value sheet:
// col0 = setting, col1 = value, col2 = requirement, col3 = notes.
function sheetToFileLevel(ws) {
  if (!ws) return [];
  const matrix = XLSX.utils.sheet_to_json(ws, {
    header: 1,
    blankrows: false,
    defval: "",
  });
  return matrix
    .map((r, i) => ({
      _key: i,
      setting: r[0] != null ? String(r[0]).trim() : "",
      value: r[1] != null ? String(r[1]) : "",
      requirement: r[2] != null ? String(r[2]).trim() : "",
      notes: r[3] != null ? String(r[3]) : "",
    }))
    .filter((row) => row.setting !== "");
}

// Parse an ArrayBuffer/Uint8Array workbook into the normalized shape the
// review + viewer UIs render.
export function parseSpecWorkbook(arrayBuffer) {
  const wb = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });
  const sheetNames = wb.SheetNames || [];
  return {
    sheetNames,
    missingSheets: REQUIRED_SHEETS.filter((s) => !sheetNames.includes(s)),
    fileLevel: sheetToFileLevel(wb.Sheets["File Level"]),
    columnLevel: sheetToGrid(wb.Sheets["Column Level"]),
    allowableValues: sheetToGrid(wb.Sheets["Allowable Values"]),
  };
}

// Convenience: read a browser File/Blob → parsed spec (used by the review modal).
export function parseSpecFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        resolve(parseSpecWorkbook(e.target.result));
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsArrayBuffer(file);
  });
}
